export default "__VITE_ASSET__90b03fcb__"